var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-subscriptions',{attrs:{"filterCourses":"false","courseId":this.$route.params.courseId}})}
var staticRenderFns = []

export { render, staticRenderFns }